var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 0L23.3847 5.07931L30.3916 4.32818L30.8686 11.359L36.7189 15.2875L32.565 20.98L34.5215 27.75L27.6803 29.4406L24.8274 35.8843L18.5 32.782L12.1726 35.8843L9.31971 29.4406L2.47853 27.75L4.43498 20.98L0.281057 15.2875L6.13142 11.359L6.60843 4.32818L13.6153 5.07931L18.5 0Z",
    fill: "#2196F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarVerified);
export default __webpack_public_path__ + "static/media/star-verified.3ea16a6b416bdd08aeb536186cc9684b.svg";
export { ForwardRef as ReactComponent };